import React, { Component } from "react";
import { Grid, Paper, ListSubheader, Snackbar } from "@material-ui/core";
import withServices from "../hocs/withServices";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import FileUpload from "./utils/FileUpload";
import Constants from "../common/constants";
import Loader from "./utils/Loader";
import { Alert, AlertTitle } from "@material-ui/lab";
import { MuiTelInput } from "mui-tel-input";

let myRefIin = {};
let myRefName = {};
let myRefSurname = {};
let myRefNumber = {};
const styles = (theme) => ({
  root: {
    //   '& .MuiFormControl-root': {
    //     width: '80%',
    //     margin: theme.spacing(1)
    //   }
  },
  pageContent: {
    [theme.breakpoints.up("sm")]: {
      margin: theme.spacing(5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(0),
      padding: theme.spacing(1),
    },
  },
  txtField: {
    [theme.breakpoints.down("xs")]: {
      paddingTop: "15px",
    },
  },
});



class UserProfile extends Component {
  state = {
    loading: true,
    // Проверка был ли пользователь подтвержден техсекретарем
    isApproved: false,
    barCode: {},

    citizenship: "",
    isMale: "true",
    needDorm: "",
    isMarried: "",
    isLocal: "",
    nationality: "",
    iin: "",
    residenceAddress: "",
    lifeAddress: "",
    factAddress: "",
    ruralQuote: false,
    locality: "",
    firstParentName: "",
    firstParentSurname: "",
    firstParentPhoneNumber: "",
    firstParentPatronymic: "",
    dateOfBirth: "",
    secondParentName: "",
    secondParentSurname: "",
    secondParentPatronymic: "",
    secondParentPhoneNumber: "",
    image3x4: null,
    imageID: "",
    imagePath: "",
    isImageUploaded: false,

    socialStatus: "",
    socialStatusFile: null,
    socialStatusFileId: "",
    socialStatusPath: "",

    contactName: "",
    contactSurname: "",
    contactPatronymic: "",
    contactPhoneNumber: "",
    position: "",
    workPlace: "",

    searchText: "",
    resultText: [],
    countries: [],
    regions: [],
    residencePlaces: [],
    lifePlaces: [],
    residenceResultPlaces: [],
    lifeResultPlaces: [],
    socialStatusTypes: [],
    selectedRegion: "",
    selectedResidenceAddress: "",
    selectedLifeAddress: "",
    selectedRegionResidence: "",
    selectedRegionLife: "",
    foreignCountry: "",
    selectedForeignCountry: "",
    foreignCountries: [],

    open: false,
    errorMessage: "",
  };

  fetchData() {
    const { personalPage, educationInfo, secretary, auth } =
      this.props.services;
    educationInfo.getCountries().then((response) => {
      this.setState({ countries: response.data });
      this.setState({ foreignCountries: response.data });
    });
    educationInfo.getAllKatoRegions().then((response) => {
      this.setState({ regions: response.data });
    });
    secretary.getSocialStatusTypes().then((response) => {
      this.setState({ socialStatusTypes: response.data });
    });
    (async () => {
      const isApproved = (
        await secretary.checkConfirm(auth.getCurrentUser().id)
      ).data;

      const barCode = (
        await secretary.getVarcode()
      ).data;

      this.setState(
        {
          isApproved,
          barCode,
        },
        () => {
          personalPage.getPersonalInformation().then((response) => {
            if (response?.data) {
              const { data } = response;
              this.setState(
                {
                  iin: data.iin,
                  nationality: data.nationality?.id,
                  citizenship: data.citizenship?.id,
                  isMale: data.isMale,
                  needDorm: data.needDorm,
                  isMarried: data.isMarried,
                  isLocal: data.isLocal,
                  residenceAddress: data.residenceAddress,
                  lifeAddress: data.lifeAddress,
                  factAddress: data.factAddress,
                  ruralQuote: data.ruralQuote,
                  locality: data.locality?.id,
                  firstParentName: data.firstParentName,
                  firstParentSurname: data.firstParentSurname,
                  firstParentPhoneNumber: data.firstParentPhoneNumber,
                  firstParentPatronymic: data.firstParentPatronymic,
                  dateOfBirth: data.dateOfBirth,
                  secondParentName: data.secondParentName,
                  secondParentSurname: data.secondParentSurname,
                  secondParentPatronymic: data.secondParentPatronymic,
                  secondParentPhoneNumber: data.secondParentPhoneNumber,
                  imageID: data.image3x4?.id,
                  imagePath: data.image3x4?.path,
                  isImageUploaded: data.image3x4?.id ? true : false,

                  socialStatus: data.socialStatus?.id,
                  socialStatusFileId: data.socialStatusFile?.id,
                  socialStatusPath: data.socialStatusFile?.path,

                  contactName: data.contactName,
                  contactSurname: data.contactSurname,
                  contactPatronymic: data.contactPatronymic,
                  position: data.position,
                  workPlace: data.workPlace,
                  resultText: this.state.countries,

                  selectedRegionResidence:
                    data.residenceAddressId?.centerKatoRegion?.codePrefix,
                  selectedRegionLife:
                    data.lifeAddressId?.centerKatoRegion?.codePrefix,
                  selectedResidenceAddress: data.residenceAddressId?.id,
                  selectedLifeAddress: data.lifeAddressId?.id,
                  foreignCountry: data.foreignCountry?.id.toString(),
                  selectedForeignCountry: data.foreignCountry?.id,
                },
                () => {
                  this.setState({
                    loading: false,
                  });

                  if (this.state.foreignCountry === "86") {
                    this.getAllKatoPlacesByRegion(this.state.selectedRegionResidence, "residence");
                    this.getAllKatoPlacesByRegion(this.state.selectedRegionLife, "life");
                  }
                }
              );
              this.state.selectedRegionResidence && educationInfo
                .getAllKatoPlacesByRegion(this.state.selectedRegionResidence)
                .then((response) => {
                  this.setState({ residencePlaces: response.data });
                  this.setState({ residenceResultPlaces: response.data });
                });
              this.state.selectedRegionLife && educationInfo
                .getAllKatoPlacesByRegion(this.state.selectedRegionLife)
                .then((response) => {
                  this.setState({ lifePlaces: response.data });
                  this.setState({ lifeResultPlaces: response.data });
                });
            } else {
              this.setState({
                loading: false,
              });
            }
          });
        }
      );
    })();
  }

  componentDidMount() {
    this.fetchData();
    if (this.state.foreignCountry === "86") {
      this.getAllKatoPlacesByRegion(this.state.selectedRegionResidence, "residence");
      this.getAllKatoPlacesByRegion(this.state.selectedRegionLife, "life");
    }
  }

  filter = (e) => {
    const keyword = e.target.value;

    if (keyword !== "") {
      const results = this.state.countries.filter((country) => {
        return country.name.toLowerCase().includes(keyword.toLowerCase());
        // Use the toLowerCase() method to make it case-insensitive
      });
      this.setState({ resultText: results });
    } else {
      this.setState({ resultText: this.state.countries });
      // If the text field is empty, show all users
    }

    this.setState({ searchText: keyword });
  };

  filterPlaces = (e, type) => {
    const keyword = e.target.value;

    if (type === "residence") {
      if (keyword !== "") {
        const results = this.state.residencePlaces.filter((place) => {
          return place.nameru.toLowerCase().includes(keyword.toLowerCase());
        });
        this.setState({ residenceResultPlaces: results });
      } else {
        this.setState({ residenceResultPlaces: this.state.residencePlaces });
      }
    }

    if (type === "life") {
      if (keyword !== "") {
        const results = this.state.lifePlaces.filter((place) => {
          return place.nameru.toLowerCase().includes(keyword.toLowerCase());
        });
        this.setState({ lifeResultPlaces: results });
      } else {
        this.setState({ lifeResultPlaces: this.state.lifePlaces });
      }
    }

    this.setState({ searchText: keyword });
  };

  // 728,турки
  // 755,узбеки
  // 756,уйгуры
  // 759,украинцы
  // 852,чеченцы
  // 857,чуваши
  nationalities = [
    {
      value: "271",
      label: "казах",
    },
    {
      value: "324",
      label: "киргиз",
    },
    {
      value: "341",
      label: "кореец",
    },
    {
      value: "367",
      label: "курд",
    },
    {
      value: "468",
      label: "молдаванин",
    },
    {
      value: "476",
      label: "мордовец",
    },
    {
      value: "571",
      label: "поляк",
    },
    {
      value: "591",
      label: "русские",
    },
    {
      value: "647",
      label: "таджик",
    },
    {
      value: "658",
      label: "татарин",
    },
    {
      value: "728",
      label: "турок",
    },
    {
      value: "755",
      label: "узбек",
    },
    {
      value: "756",
      label: "уйгур",
    },
    {
      value: "759",
      label: "украинец",
    },
    {
      value: "852",
      label: "чеченец",
    },
    {
      value: "857",
      label: "чуваш",
    },
    {
      value: "23",
      label: "азербайджанец",
    },
    {
      value: "97",
      label: "башкир",
    },
    {
      value: "104",
      label: "белорус",
    },
    {
      value: "165",
      label: "грек",
    },
    {
      value: "203",
      label: "дунганин",
    },
    {
      value: "209",
      label: "еврей",
    },
    {
      value: "247",
      label: "ингуш",
    },
    {
      value: "57",
      label: "армянин",
    },
    {
      value: "499",
      label: "немец",
    },
    {
      value: "925",
      label: "пакистанец",
    },
    {
      value: "1000",
      label: "другое",
    },
  ];

  handleFirstParentPhoneNumberChange = (firstParentPhoneNumber) => {
    this.setState({ firstParentPhoneNumber });
  }

  handleSecondParentPhoneNumberChange = (secondParentPhoneNumber) => {
    this.setState({ secondParentPhoneNumber });
  }

  handleForeignCountryChange = (event) => {
    const selectedCountry = event.target.value.toString();
    this.setState({ foreignCountry: selectedCountry });

    if (selectedCountry !== "86") {
      this.setState({
        selectedRegionResidence: "",
        selectedRegionLife: "",
        selectedResidenceAddress: "",
        selectedLifeAddress: "",
      });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const { state } = this;
    // console.log(state.firstParentName.length)
    if (state.iin.length < 1) {
      myRefIin.current.reportValidity();
    } else if (!state.firstParentName) {
      myRefName.current.reportValidity();
    } else if (!state.firstParentSurname) {
      myRefSurname.current.reportValidity();
    } else if (!state.firstParentPhoneNumber) {
      myRefNumber.current.reportValidity();
    } else if (state.iin.length !== 12) {
      this.setState({ errorMessage: "Введите правильный ИИН", open: true });
    } else if (!state.isImageUploaded) {
      this.setState({ errorMessage: "Загрузите фото 3x4", open: true });
    }
    else {
      const data = {
        iin: state.iin || null,
        nationality: state.nationality || null,
        citizenship: state.citizenship || null,
        isMale: state.isMale || null,
        needDorm: state.needDorm || null,
        isMarried: state.isMarried || null,
        isLocal: state.isLocal || null,
        residenceAddress: state.residenceAddress || null,
        lifeAddress: state.lifeAddress || null,
        locality: state.locality || null,
        firstParentName: state.firstParentName || null,
        firstParentSurname: state.firstParentSurname || null,
        firstParentPhoneNumber: state.firstParentPhoneNumber || null,
        firstParentPatronymic: state.firstParentPatronymic || null,
        dateOfBirth: state.dateOfBirth || null,
        secondParentName: state.secondParentName || null,
        secondParentSurname: state.secondParentSurname || null,
        secondParentPatronymic: state.secondParentPatronymic || null,
        secondParentPhoneNumber: state.secondParentPhoneNumber || null,
        image3x4Id: state.imageID || null,
        socialStatus: state.socialStatus || null,
        socialStatusFileId: state.socialStatusFileId || null,
        socialStatusPath: state.socialStatusPath || null,
        contactName: state.contactName || null,
        contactSurname: state.contactSurname || null,
        contactPatronymic: state.contactPatronymic || null,
        workPlace: state.workPlace || null,
        position: state.position || null,
        lifeAddressId: state.selectedLifeAddress || null,
        residenceAddressId: state.selectedResidenceAddress || null,
        factAddress: state.factAddress || null,
        ruralQuote: state.ruralQuote || false,
        foreignCountry: state.foreignCountry || null,
      };
      const personalPage = this.props.services.personalPage;
      personalPage
        .personalInformation(data)
        .then(() => {
          this.setState({ errorMessage: null });
          alert("Ваши данные успешно сохранены");
          this.fetchData();
        })
        .catch(() => {
          alert("В форме присутствуют некорректно заполненные поля");
        });
    }
  };

  getAllKatoPlacesByRegion = (id, type) => {
    if (type === "residence") {
      this.props.services.educationInfo
        .getAllKatoPlacesByRegion(id)
        .then((response) => {
          this.setState({ residencePlaces: response.data });
          this.setState({ residenceResultPlaces: response.data });
        });
    }
    if (type === "life") {
      this.props.services.educationInfo
        .getAllKatoPlacesByRegion(id)
        .then((response) => {
          this.setState({ lifePlaces: response.data });
          this.setState({ lifeResultPlaces: response.data });
        });
    }
  };



  render() {
    const { classes } = this.props;
    const { state } = this;
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        {this.state.open === true && this.state.errorMessage && (
          <Snackbar
            open={this.state.open}
            autoHideDuration={6000}
            onClose={() => this.setState({ open: false })}
          >
            <Alert
              onClose={() => this.setState({ open: false })}
              severity="error"
              variant="filled"
              sx={{ width: '100%' }}
            >
              {this.state.errorMessage}
            </Alert>
          </Snackbar>
        )}
        <Paper className={classes.pageContent}>
          <form
            onSubmit={(event) => this.handleSubmit(event)}
            className={classes.root}
            noValidate
            autoComplete="off"
          >
            <Typography variant="h5">Личные данные</Typography>
            <br />
            {this.state.isApproved && (
              <Grid item xs={12} md={8} lg={10}>
                {this.state.barCode && this.state.barCode.password && (
                  <Alert severity="info">
                    <AlertTitle>Ваша почта: <a type="email" href={`mailto:${this.state.barCode.varCode}@astanait.edu.kz`}>{this.state.barCode.varCode}@astanait.edu.kz</a></AlertTitle>
                    <AlertTitle>Первичный пароль: {this.state.barCode.password}</AlertTitle>
                    <AlertTitle>{`Это ваши данные для взаимодействия с системами университета.`}</AlertTitle>
                    <AlertTitle>{`Первичный пароль - пароль который изначально выдается университетом, для входа. При необходимости вы можете изменить пароль после входа.`}</AlertTitle>
                    <AlertTitle>{`Если у вас какие-то проблемы с вашим аккаунтом обратитесь по почте - `} <a type="email" href={`mailto:support_du@astanait.edu.kz`}>support_du@astanait.edu.kz</a></AlertTitle>
                  </Alert>
                )}
              </Grid>
            )}
            <Grid container justify="center" spacing={3}>
              {this.state.isApproved && (
                <Grid item xs={12}>
                  <Typography align="center" variant="h6">
                    Вы не можете ничего менять, так как ваши данные уже
                    подтверждены
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  required
                  inputRef={myRefIin}
                  margin="normal"
                  value={state.iin}
                  label="ИИН"
                  onChange={(e) => {
                    let value = e.target.value;

                    value = value.replace(/[^0-9]/gi, "");

                    this.setState({
                      iin: value,
                    });
                  }}
                  error={state.iin?.length < 12 && state.iin?.length > 0}
                  helperText={
                    state.iin?.length < 12 && state.iin?.length > 0
                      ? "ИИН не может быть меньше 12 цифр"
                      : " "
                  }
                  inputProps={{ maxLength: 12 }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  select
                  variant="outlined"
                  fullWidth
                  value={state.isMale}
                  label="Пол"
                  onChange={(event) => {
                    this.setState({
                      isMale: event.target.value,
                    });
                  }}
                >
                  <MenuItem value={"true"}>Мужской</MenuItem>
                  <MenuItem value={"false"}>Женский</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  select
                  variant="outlined"
                  fullWidth
                  value={state.needDorm}
                  label="Общежитие"
                  onChange={(event) => {
                    this.setState({
                      needDorm: event.target.value,
                    });
                  }}
                >
                  <MenuItem value={"true"}>Нуждается</MenuItem>
                  <MenuItem value={"false"}>Не нуждается</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="date"
                  helperText="Дата рождения"
                  value={state.dateOfBirth}
                  onChange={(event) =>
                    this.setState({
                      dateOfBirth: event.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  select
                  variant="outlined"
                  value={state.socialStatus}
                  fullWidth
                  label="Социальный статус"
                  className={classes.specialInput}
                  onChange={(event) => {
                    this.setState({
                      socialStatus: event.target.value,
                    });
                  }}
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>
                  {this.state.socialStatusTypes.map((socialStatusType) => (
                    <MenuItem
                      key={socialStatusType.id}
                      value={socialStatusType.id}
                    >
                      {socialStatusType.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  select
                  variant="outlined"
                  fullWidth
                  value={state.isMarried}
                  label="Семейное положение"
                  onChange={(event) => {
                    this.setState({
                      isMarried: event.target.value,
                    });
                  }}
                >
                  <MenuItem value={"true"}>Женат/Замужем</MenuItem>
                  <MenuItem value={"false"}>Холост/Не замужем</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  select
                  variant="outlined"
                  fullWidth
                  value={state.isLocal}
                  label="Проживает в городе Астана"
                  onChange={(event) => {
                    this.setState({
                      isLocal: event.target.value,
                    });
                  }}
                >
                  <MenuItem value={"true"}>Да</MenuItem>
                  <MenuItem value={"false"}>Нет</MenuItem>
                </TextField>
              </Grid>


              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Документ подтверждающий социальный статус (в формате pdf) (при наличии)"
                  fileType={Constants.FILE_TYPES.documentConfirmingSocialStatus}
                  file={this.state.socialStatusFileId}
                  filePath={this.state.socialStatusPath}
                  handleDelete={() => {
                    this.fetchData();
                  }}
                  handleSetFileId={(fileId) =>
                    this.setState({ socialStatusFileId: fileId })
                  }
                />
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  select
                  variant="outlined"
                  value={state.nationality}
                  fullWidth
                  label="Национальность"
                  className={classes.specialInput}
                  onChange={(event) => {
                    this.setState({
                      nationality: event.target.value,
                    });
                  }}
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>
                  {this.nationalities.map((option) => (
                    <MenuItem value={option.value}>{option.label}</MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  select
                  variant="outlined"
                  value={state.citizenship}
                  fullWidth
                  label="Гражданство"
                  onChange={(e) =>
                    this.setState({
                      citizenship: e.target.value,
                    })
                  }
                  onClose={() =>
                    this.setState({
                      searchText: "",
                    })
                  }
                >
                  <ListSubheader>
                    <TextField
                      size="small"
                      placeholder="Введите для поиска или выберите в меню"
                      fullWidth
                      onChange={(e) => this.filter(e)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                      inputProps={{
                        style: { backgroundColor: "white" },
                      }}
                    />
                  </ListSubheader>
                  {this.state.resultText.map((country) => (
                    <MenuItem key={country.id} value={country.id}>
                      {country.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  select
                  variant="outlined"
                  value={state.foreignCountry}
                  fullWidth
                  label="Страна, откуда прибыл"
                  onChange={this.handleForeignCountryChange}
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>
                  {this.state.foreignCountries.map((country) => (
                    <MenuItem key={country.id} value={country.id.toString()}>
                      {country.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              {this.state.foreignCountry === "86" && (
                <>
                  <Grid item xs={12} md={8} lg={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      select
                      label="Область прописки (КАТО)"
                      value={this.state.selectedRegionResidence}
                      onChange={(e) => {
                        this.setState({
                          selectedRegionResidence: e.target.value,
                        });
                        this.getAllKatoPlacesByRegion(
                          e.target.value,
                          "residence"
                        );
                      }}
                    >
                      <MenuItem value="none" disabled>
                        Выберите один из вариантов
                      </MenuItem>
                      {this.state.regions.map((region) => (
                        <MenuItem key={region.id} value={region.codePrefix}>
                          {region.nameru}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={8} lg={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      select
                      SelectProps={{
                        MenuProps: { autoFocus: false },
                      }}
                      label="Районный центр прописки (КАТО)"
                      value={this.state.selectedResidenceAddress}
                      onChange={(e) => {
                        this.setState({
                          selectedResidenceAddress: e.target.value,
                        });
                      }}
                      onClose={() =>
                        this.setState({
                          searchText: "",
                        })
                      }
                    >
                      <ListSubheader>
                        <TextField
                          size="small"
                          autoFocus
                          placeholder="Введите для поиска или выберите в меню"
                          fullWidth
                          onChange={(e) => this.filterPlaces(e, "residence")}
                          onKeyDown={(e) => {
                            if (e.key !== "Escape") {
                              e.stopPropagation();
                            }
                          }}
                          inputProps={{
                            style: { backgroundColor: "white" },
                          }}
                        />
                      </ListSubheader>
                      {this.state.residenceResultPlaces.map((place) => (
                        <MenuItem key={place.id} value={place.id}>
                          {place.nameru}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={8} lg={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      select
                      children
                      label="Область проживания (КАТО)"
                      value={this.state.selectedRegionLife}
                      onChange={(e) => {
                        this.setState({
                          selectedRegionLife: e.target.value,
                        });
                        this.getAllKatoPlacesByRegion(e.target.value, "life");
                      }}
                    >
                      <MenuItem value="none" disabled>
                        Выберите один из вариантов
                      </MenuItem>
                      {this.state.regions.map((region) => (
                        <MenuItem key={region.id} value={region.codePrefix}>
                          {region.nameru}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={8} lg={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      select
                      SelectProps={{
                        MenuProps: { autoFocus: false },
                      }}
                      label="Районный центр проживания (КАТО) "
                      value={this.state.selectedLifeAddress}
                      onChange={(e) => {
                        this.setState({
                          selectedLifeAddress: e.target.value,
                        });
                      }}
                      onClose={() =>
                        this.setState({
                          searchText: "",
                        })
                      }
                    >
                      <ListSubheader>
                        <TextField
                          size="small"
                          autoFocus
                          placeholder="Введите для поиска или выберите в меню"
                          fullWidth
                          onChange={(e) => this.filterPlaces(e, "life")}
                          onKeyDown={(e) => {
                            if (e.key !== "Escape") {
                              e.stopPropagation();
                            }
                          }}
                          inputProps={{
                            style: { backgroundColor: "white" },
                          }}
                        />
                      </ListSubheader>
                      {this.state.lifeResultPlaces.map((place) => (
                        <MenuItem key={place.id} value={place.id}>
                          {place.nameru}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </>
              )}
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label='Фактический адрес проживания(пример: "Акмолинская область, г. Астана, ул. Достык, кв. 20")'
                  value={state.factAddress}
                  onChange={event => this.setState({
                    factAddress: event.target.value
                  })}
                />
              </Grid>
              {/* <Grid item xs={12} md={8} lg={10}>
                <FormControlLabel
                  style={{ textAlign: "center" }}
                  control={
                    <Checkbox
                      checked={this.state.ruralQuote}
                      onChange={() => this.setState({ ruralQuote: !this.state.ruralQuote })}
                      color="primary"
                    />
                  }
                  label="Имеется сельская квота"
                />
              </Grid> */}
              {/* <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  label='Адрес прописки'
                  value={state.residenceAddress}
                  fullWidth
                  onChange={event => this.setState({
                    residenceAddress: event.target.value
                  })}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label='Текущий адрес'
                  value={state.lifeAddress}
                  onChange={event => this.setState({
                    lifeAddress: event.target.value
                  })}
                />
              </Grid> */}
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Фото 3x4 (.png, .jpeg, .jpg, .jfif)"
                  fileType={Constants.FILE_TYPES.image3x4}
                  file={this.state.imageID}
                  filePath={this.state.imagePath}
                  handleSetFileId={(fileId) => {
                    this.setState({
                      imageID: fileId,
                      isImageUploaded: true
                    })
                  }}
                  handleDelete={() => {
                    this.fetchData();
                  }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  required
                  inputRef={myRefName}
                  fullWidth
                  className={classes.txtField}
                  variant="outlined"
                  value={state.firstParentName}
                  label="Имя первого родителя (опекуна)"
                  onChange={(event) =>
                    this.setState({
                      firstParentName: event.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  required
                  inputRef={myRefSurname}
                  className={classes.txtField}
                  variant="outlined"
                  value={state.firstParentSurname}
                  label="Фамилия первого родителя (опекуна)"
                  onChange={(event) =>
                    this.setState({
                      firstParentSurname: event.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  className={classes.txtField}
                  variant="outlined"
                  value={state.firstParentPatronymic}
                  label="Отчество первого родителя (опекуна)"
                  onChange={(event) =>
                    this.setState({
                      firstParentPatronymic: event.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                {/* <InputMask
                  mask="+7(999)9999999"
                  defaultValue="+7"
                  value={state.firstParentPhoneNumber}
                  onChange={(event) =>
                    this.setState({
                      firstParentPhoneNumber: event.target.value,
                    })
                  }
                >
                  {(inputProps) => ( */}

                <MuiTelInput
                  fullWidth
                  required
                  inputRef={myRefNumber}
                  className={classes.txtField}
                  defaultCountry="KZ"
                  variant="outlined"
                  label="Номер телефона первого родителя (опекуна)"
                  value={this.state.firstParentPhoneNumber}
                  onChange={(event) => {
                    this.handleFirstParentPhoneNumberChange(event)
                  }}
                />
                {/* <TextField
                  fullWidth
                  required
                  inputRef={myRefNumber}
                  className={classes.txtField}
                  variant="outlined"
                  label="Номер телефона первого родителя (опекуна)"
                  type="tel"
                  value={state.firstParentPhoneNumber}
                  onChange={(event) =>
                    this.setState({
                      firstParentPhoneNumber: event.target.value,
                    })
                  } /> */}
                {/*    )}
                 </InputMask> */}
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  className={classes.txtField}
                  variant="outlined"
                  value={state.secondParentName}
                  label="Имя второго родителя (опекуна)"
                  onChange={(event) =>
                    this.setState({
                      secondParentName: event.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  className={classes.txtField}
                  value={state.secondParentSurname}
                  label="Фамилия второго родителя (опекуна)"
                  onChange={(event) =>
                    this.setState({
                      secondParentSurname: event.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  className={classes.txtField}
                  variant="outlined"
                  value={state.secondParentPatronymic}
                  label="Отчество второго родителя (опекуна)"
                  onChange={(event) =>
                    this.setState({
                      secondParentPatronymic: event.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                {/* <InputMask
                  mask="+7(999)9999999"
                  defaultValue="+7"
                  value={state.secondParentPhoneNumber}
                  onChange={(event) =>
                    this.setState({
                      secondParentPhoneNumber: event.target.value,
                    })
                  }
                >
                  {(inputProps) => ( */}
                <MuiTelInput
                  fullWidth
                  inputRef={myRefNumber}
                  className={classes.txtField}
                  variant="outlined"
                  label="Номер телефона второго родителя (опекуна)"
                  value={this.state.secondParentPhoneNumber}
                  onChange={(event) =>
                    this.handleSecondParentPhoneNumberChange(event)
                  }
                  defaultCountry="KZ"
                />
                {/* )}
                </InputMask> */}

              </Grid>
              <Typography variant="h5">
                Дальнейшие поля относятся только к поступающим на магистратуру
              </Typography>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  className={classes.specialInput}
                  variant="outlined"
                  value={state.workPlace}
                  label="Место работы"
                  onChange={(event) =>
                    this.setState({
                      workPlace: event.target.value,
                    })
                  }
                ></TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  className={classes.specialInput}
                  variant="outlined"
                  value={state.position}
                  label="Должность"
                  onChange={(event) =>
                    this.setState({
                      position: event.target.value,
                    })
                  }
                ></TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  className={classes.specialInput}
                  variant="outlined"
                  value={state.contactSurname}
                  label="Фамилия контактного лица"
                  onChange={(event) =>
                    this.setState({
                      contactSurname: event.target.value,
                    })
                  }
                ></TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  className={classes.specialInput}
                  variant="outlined"
                  value={state.contactName}
                  label="Имя контактного лица"
                  onChange={(event) =>
                    this.setState({
                      contactName: event.target.value,
                    })
                  }
                ></TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  className={classes.specialInput}
                  variant="outlined"
                  value={state.contactPatronymic}
                  label="Отчество контактного лица"
                  onChange={(event) =>
                    this.setState({
                      contactPatronymic: event.target.value,
                    })
                  }
                ></TextField>
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <Grid container justify="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleSubmit}
                    disabled={this.state.isApproved}
                  >
                    Сохранить
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </>
    );
  }
}

export default withStyles(styles)(withServices()(UserProfile));
